// extracted by mini-css-extract-plugin
export default {"secondary-block":"Nj4EVP","item":"dc9q4n"};